export default ({ palette, typography }) => ({
  activeColor: palette.text,
  color: palette.secondary,
  fontFamily: typography.h4.fontFamily,
  fontSize: 24,
  fontWeight: typography.h4.fontWeight,
  hoverColor: palette.secondary,
});
